




































import { Component, Prop } from 'vue-property-decorator';
import BaseFormField from './BaseFormField.vue';
import FormFieldWrapper from './FormFieldWrapper.vue';
import Tooltip from '../Tooltip.vue';

/**
 * A Text Input form field
 * @example ../../docs/TextInput.Example.md
 */
@Component({
	name: 'TextInput',
	components: {
		FormFieldWrapper,
		Tooltip
	}
})
export default class TextInput extends BaseFormField {

	/* Props
	============================================*/

	@Prop({type: Boolean, required: false})
	readonly hideLabel: boolean;

	@Prop({type: String, required: false})
	readonly label: string;
}

